import eventBus from './event-bus';
import {
  SubscribedToAccount, UnsubscribedFromAccount, AccountServiceEnabled, AccountServiceDisabled,
} from './events';

export function onSubscribedToAccount(listener: { (event: SubscribedToAccount): void }) {
  eventBus.$on(SubscribedToAccount.eventName, listener);
}

export function offSubscribedToAccount(listener: { (event: SubscribedToAccount): void }) {
  eventBus.$off(SubscribedToAccount.eventName, listener);
}

export function onUnsubscribedFromAccount(listener: { (event: UnsubscribedFromAccount): void }) {
  eventBus.$on(UnsubscribedFromAccount.eventName, listener);
}

export function offUnsubscribedFromAccount(listener: { (event: UnsubscribedFromAccount): void }) {
  eventBus.$off(UnsubscribedFromAccount.eventName, listener);
}

export function onAccountServiceEnabled(listener: { (event: AccountServiceEnabled): void }) {
  eventBus.$on(AccountServiceEnabled.eventName, listener);
}

export function onAccountServiceDisabled(listener: { (event: AccountServiceDisabled): void }) {
  eventBus.$on(AccountServiceDisabled.eventName, listener);
}
